module.exports = "/images/PR_Logo-500w.png?bc4b866297fa630afbbb22559eb634da";